export enum CatchupView {
    Graph = "Graph",
    Grid = "Grid",
}